import styled from 'styled-components';
import { CenteredButton } from 'components/reusable/Authentication/AuthenticationPanel/AuthenticationPanel.styled';

const CenteredButtonWithMargin = styled(CenteredButton)`
  margin-top: 60px;
`;

export default { CenteredButtonWithMargin };
